import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import * as Admin from "../store/ducks/admin.duck";
import { Button, Form, Row, Col } from "react-bootstrap";
import { Grid } from "@material-ui/core";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../../_metronic/_assets/css/app2.css";

export default function ProviderProgramBio(props) {
  const dispatch = useDispatch();
  const { program, providerID, onCloseCustomBio } = props;

  const [providerBio, setProviderBio] = useState("");

  useEffect(() => {
    setProviderBio(program?.programBio ?? "");
  }, [program?.programID, program?.programBio]);

  function addProviderBIO() {
    // Update BIO
    dispatch(
      Admin.actions.putProviderProgramBio({
        id: program.programID,
        bio: providerBio,
        psychologistID: providerID,
      }),
    );

    onCloseCustomBio();
  }

  return (
    <Grid item md={12}>
      <Row>
        <Col md="12" className="quill-field">
          <Form.Group>
            <Form.Label>Custom Bio for Program - {program?.name}</Form.Label>

            <ReactQuill theme="snow" value={providerBio} onChange={setProviderBio} />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <Grid container spacing={0} padding={6} justifyContent="space-between">
            <Button variant="light" onClick={onCloseCustomBio}>
              Cancel
            </Button>

            <Button variant="success" size="sm" disabled={!program} onClick={addProviderBIO}>
              Save
            </Button>
          </Grid>
        </Col>
      </Row>
    </Grid>
  );
}
